/**
 * The OAuth `state` round-trips through the identity provider as a query
 * param, so on the way back it is untrusted and loosely typed: it may be
 * absent, repeated (`string[]` from `queryString.parse`), malformed, or
 * tampered with. Every reader needs the same guard, so it lives here once.
 */
export const parseStateObject = (
  state: unknown
): Record<string, unknown> | null => {
  if (typeof state !== 'string' || !state) {
    return null
  }
  try {
    const parsed: unknown = JSON.parse(state)
    if (!parsed || typeof parsed !== 'object') {
      return null
    }
    return parsed as Record<string, unknown>
  } catch {
    return null
  }
}
